import { createStyles, IconButton, makeStyles, Theme, Typography } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import React from 'react';

export enum GenericToastKind {
  Error = 'ERROR',
  Warning = 'WARNING',
  Success = 'SUCCESS',
  Info = 'INFO',
}

const useStyles = (kind: GenericToastKind) =>
  makeStyles((theme: Theme) => {
    const backgroundColor = {
      [GenericToastKind.Success]: theme.palette.primary.main,
      [GenericToastKind.Error]: theme.palette.error.main,
      [GenericToastKind.Warning]: theme.palette.warning.main,
      [GenericToastKind.Info]: theme.palette.info.main,
    }[kind];

    return createStyles({
      toast: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor,
        padding: '8px 80px',
        margin: '0 -80px',
      },
    });
  });

interface GenericToastProps {
  kind: GenericToastKind;
  message?: string;
  onDismiss?: () => void;
}

export const GenericToast: React.FC<GenericToastProps> = (props) => {
  const classes = useStyles(props.kind)();
  const IconComponent = {
    [GenericToastKind.Success]: CheckCircleIcon,
    [GenericToastKind.Error]: CancelIcon,
    [GenericToastKind.Warning]: WatchLaterIcon,
    [GenericToastKind.Info]: InfoIcon,
  }[props.kind];

  return (
    <div className={classes.toast}>
      {<IconComponent fontSize="small" style={{ marginRight: 10 }} />}
      <div style={{ flex: 1 }}>
        {!!props.message ? <Typography variant="body2">{props.message}</Typography> : props.children}
      </div>
      <IconButton onClick={props.onDismiss}>
        <CloseIcon />
      </IconButton>
    </div>
  );
};
